import debounce from '~/utils/events/debounce';
import {setLoading} from '../Store/creators/common';
import {setFilter} from '../Store/creators/filter';
import {setOverview} from '../Store/creators/visualData';
import {dispatch} from '../Store/index';
import {StateVisualOverview} from '../Store/State';
import sendVisualRequest from '../utils/sendVisualRequest';

// tslint:disable:max-line-length
const data = {
	front: {
		view: 'front',
		nextView: '',
		image: '/images/choose-visual/overview/01.jpg?2',
		map: [
			{
				path: 'M984.5 562.635L995.834 440.5L999.5 401L1001 400.5C1000.67 398.5 1000.6 394.4 1003 392L1004 367.5C1003 365 1005 355.5 1005 353C1005 351 1006.67 349.5 1007.5 349L1009.5 315.5L1022.5 303L1033 306.5V293L1046.5 280.5L1058.5 284.5L1073 270L1079 264L1101.5 272L1104.5 269.891L1127.5 277.768V286.829L1143.5 292.5L1151 285.816L1175.24 294.119V297.633L1196.5 304.913L1199 302.256L1223 310.475L1225 308.5L1247.5 316.222V322.38L1266.83 329L1272 323.5L1295.5 331.5V338.819L1314 345.155L1320.51 338.5L1346.5 347.5V352.772L1368.5 360.307L1372.5 356.307L1382 359.561L1399.5 365.554V374.438L1424.47 382.991L1429.5 377.5L1475.5 393L1468.5 424.5L1461.5 433.5L1460.52 438.895C1460.76 437.784 1462.34 437 1463.5 437C1465 437 1467 435 1467 439C1467 443 1464.5 458.5 1463.5 459.5C1462.7 460.3 1461.5 460.167 1461 460L1459 470L1452.5 478.5L1459.5 481L1433.5 601.5L1432.5 603L1428.5 629L1246 864.5L1233 858L1232 865.5L1230 867L1227.5 889.5L1142 1000.5L693 806L694 749.5L653 791L266 624L250.5 479L257.521 474.5L256.345 463.5L258.184 462L256.634 447.5L254.5 446.5L251 413.5L274.185 397.05L278.866 398.857L289.705 391.167L289.758 386L309.547 371.959L314.22 373.773L322 368.252V358L341.138 344.416L345.816 346.226L355.5 339L354 309.5L381.935 289.426L384.49 290.605L400.9 278.878V272.5L421.5 257.841L428.34 260.998L432.9 257.739V250L447.958 238.591L454.49 241.605L462.9 235.595V230.883L472.9 223.736V220.5L492.5 206.302L497.49 208.605L508.9 200.451V195.168L523.761 184.548L530.49 187.605L539.5 181.5V173.5C540.3 174.3 608.833 201 643.5 214.5V228.5L645.5 229.5V263L643 265.5L646.5 442.05L639.5 448L653.857 453L659.211 448.836L684.02 458.15L689.605 453.495L711.5 461.715L745.5 474.478V477.853L767.202 486V495.5L783 501.5L785.181 499.5L803.317 506.308L811.368 499.204L869.429 521V532.5L884 538V542L887.74 538L894 540.35L930.826 554.174L939.5 546L984.5 562.635ZM984.5 562.635L999.5 568.18M999.5 568.18L1045 585L1044.5 593L1100.5 612.938L1088.8 626.101L1088 638.5L1067.5 630.5V618.106L997.958 592L999.5 568.18Z',
				target: '1',
				available: 1,
			},
			{
				path: 'M554.5 161.5L539.5 173.5C540.3 174.3 608.833 201 643.5 214.5V228.5L645.5 229.5V263L643 265.5L646.5 442.05L668.5 424L679.5 428V447L711.5 459V461.715L745.5 474.478V477.853L767.202 486V495.5L783 501.5L785.181 499.5L803.317 506.308L811.368 499.204L869.429 521V532.5L884 538V542L887.74 538L894 540.35L995.834 440.5L999.5 401L1001 400.5C1000.67 398.5 1000.6 394.4 1003 392L1004 367.5C1003 365 1005 355.5 1005 353C1005 351 1006.67 349.5 1007.5 349L1009.5 315.5L1022.5 303L1033 306.5V293L1046.5 280.5L1058.5 284.5L1073 270L1054.23 264L1006 249L878 365.5L722 311L723.5 189L600.5 149.5V146.5L584.5 141L569 152V160L563 164.5L554.5 161.5Z',
				target: '2',
				available: 1,
			},
			{
				path: 'M1073 270L1079 264L1101.5 272L1104.5 269.891L1127.5 277.768V286.829L1143.5 292.5L1151 285.816L1175.24 294.119V297.633L1196.5 304.913L1199 302.256L1223 310.475L1225 308.5L1247.5 316.222V322.38L1266.83 329L1272 323.5L1295.5 331.5V338.819L1314 345.155L1320.51 338.5L1346.5 347.5V352.772L1368.5 360.307L1372.5 356.307L1382 359.561L1391 310L1392.5 308.5L1396 309.5L1409.5 294.5L1412 280L1413 279H1415L1428.5 264V262.5L1430.83 260.5H1432L1453 152.5L1457 149L1463.5 115.5L1457 113.5L1451.65 119.908L1433.36 114.706L1428.82 118.592L1413.22 114.157L1413.16 107.571L1395.65 102.594L1389.9 107.526L1373.23 102.787L1373.17 96.2011L1349.72 89.5359L1343.97 94.4685L1329.21 90.2747L1329.15 83.6887L1307.67 77.5811L1301.91 82.5137L1284.22 77.4827L1284.15 70.8966L1263.99 65.1637L1262.5 66.4398L1241 60.0112L1236.46 63.9055L1219.22 59.0058L1219.16 52.4198L1199.23 46.8129L1193.53 51.7016L1177.34 47.0992L1177.28 40.5132L1157.73 34.9565L1155.93 36.5L1133.5 30L1121 40V44.5L1083 76L1080.5 101L1078 102.5L1076 126L1077 127L1076 142L1073.5 143.5L1072.5 155L1065.5 160L1054.23 264L1073 270Z',
				target: '3',
				available: 1,
			},
		],
	},
};

async function fetchVisualOverview( view: string ): Promise<void>
{
	dispatch( setLoading( true ) );
	
	const serverData = await sendVisualRequest( {overviewView: view} );
	
	if ( !( view in data ) )
	{
		// tslint:disable-next-line:no-parameter-reassignment
		view = 'front';
	}
	
	const viewData = {...(data as any)[view]} as StateVisualOverview;
	
	if ( serverData.overview && serverData.overview.map )
	{
		const sections = new Map<string | number, number>();
		
		for ( const item of serverData.overview.map )
		{
			sections.set( item.target, item.available );
		}
		
		for ( const item of viewData.map )
		{
			if ( sections.has( item.target ) )
			{
				// tslint:disable-next-line:no-non-null-assertion
				item.available = sections.get( item.target )!;
			}
			else
			{
				item.available = 0;
			}
		}
	}
	
	// TODO:
	dispatch(
		setFilter( serverData.filter ),
	);
	
	dispatch( setOverview( viewData ) );
	
	dispatch( setLoading( false ) );
}

const debouncedFetchVisualOverview = debounce( fetchVisualOverview, 200 );

/**
 * Module.
 */
export {
	fetchVisualOverview as default,
	debouncedFetchVisualOverview,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/asyncActions/fetchVisualOverview.ts